import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppChallengeInAppPage } from './app-challenge-in-app';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppChallengeInAppPage,
  ],
  imports: [
    IonicPageModule.forChild(AppChallengeInAppPage),
    PipesModule,
    DirectivesModule,
  ],
})
export class AppChallengeInAppPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-challenge-in-app/app-challenge-in-app.module.ts